import { ThemeProvider } from "@mui/material/styles";
import { lightTheme } from "./theme/createAppTheme";
import AppLayout from "./pages/AppLayout/AppLayout.component";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import UserApplications from "./pages/UserApplications/UserApplications.component";
import ProtectedRoute from "./components/ProtectedRoutes/ProtectedRoutes.component";
import Contact from "./pages/Contact/Contact.component";
import About from "./pages/About/About.component";
import Services from "./pages/Services/Service.component";
import UserBasicProfile from "./pages/UserDetails/UserBasicProfile/UserBasicProfile.component";
import UserDetails from "./pages/UserDetails/UserDetails.component";
import AppliedApplicationDetails from "./components/common/AppliedApplicationDetails/AppliedApplicationDetails.component";
import HomePage from "./pages/HomePage/HomePage.component";
import ApplicationCscCardContainer from "./pages/ApplicationCscCardContainer/ApplicationCscCardContainer.component";
import ServiceCentersMap from "./components/ServiceCentersMap/ServiceCentersMap.component";
import PlaceOrder from "./components/PlaceOrder/PlaceOrder.component";
import ApplicationDetails from "./components/common/ApplicationsDetails/ApplicationsDetails.component";
import DocumentUploadAndVerification from "./components/common/DocumentUploadAndVerification/DocumentUploadAndVerification.component";
import DocumentVerification from "./components/DocumentVerification/DocumentVerification.component";
import { FirebaseAuth } from "./auth/FirebaseAuth";
import ErrorBoundary, { RouteError } from "./components/common/ErrorBoundary/ErrorBoundary.component";
import CSCOwnerPortal from "./pages/CSCOwnerPortal/CSCOwnerPortal.component";
import CSCOwnerDashboard from "./pages/CSCOwnerPortal/CSCOwnerDashboard/CSCOwnerDashboard.component";
import CSCOwnerProfile from "./pages/CSCOwnerPortal/CSCOwnerProfile/CSCOwnerProfile.component";
import CSCOwnerAddService from "./pages/CSCOwnerPortal/CSCOwnerAddService/CSCOwnerAddService.component";
import CSCOwnerRequests from "./pages/CSCOwnerPortal/CSCOwnerRequests/CSCOwnerRequests.component";
import CSCOwnerServices from "./pages/CSCOwnerPortal/CSCOwnerServices/CSCOwnerServices.component";
import CSCOwnerCategories from "./pages/CSCOwnerPortal/CSCOwnerCategories/CSCOwnerCategories.component";
import ServicesExplorer from "./pages/Services/ServicesExplorer/ServicesExplorer.component";
import LoginPage from "./pages/Authentication/LoginPage/LoginPage.component";
import seedMockDataIfNeeded from "./pages/CSCOwnerPortal/CSCOwnerServices/seedMockData";
import seedMockCategoriesIfNeeded from "./pages/CSCOwnerPortal/CSCOwnerCategories/seedMockCategories";
import './App.scss';

seedMockDataIfNeeded();
seedMockCategoriesIfNeeded();
const router = createBrowserRouter([
  {
    path: "/login",
    element: <LoginPage />,
    errorElement: <RouteError />,
  },
  {
    path: "/csc-portal",
    element: <ProtectedRoute><CSCOwnerPortal /></ProtectedRoute>,
    errorElement: <RouteError />,
    children: [
      { index: true,           element: <CSCOwnerDashboard /> },
      { path: "profile",       element: <CSCOwnerProfile /> },
      { path: "add-service",   element: <CSCOwnerAddService /> },
      { path: "services",      element: <CSCOwnerServices /> },
      { path: "requests",      element: <CSCOwnerRequests /> },
      { path: "categories",    element: <CSCOwnerCategories /> },
    ],
  },
  {
    path: "/",
    element: <AppLayout />,
    errorElement: <RouteError />,
    children: [
      {
        path: '/',
        element: <HomePage />
      },
      {
        path: "services",
        element: <Services />,
        children: [
          { index: true, element: <ServicesExplorer /> },
          {
            path: ":applicationsCategoryName/:applicationName",
            element: <ApplicationCscCardContainer />,
            children: [
              {
                path: '',
                element: <ApplicationDetails/>
              },
              {
                path: 'verify-documents',
                element: <ProtectedRoute><DocumentVerification /></ProtectedRoute>
              },
              {
              path: 'service-centers',
              element: <ProtectedRoute> <ServiceCentersMap /></ProtectedRoute>
            },
            {
              path: 'place-order',
              element:<ProtectedRoute><PlaceOrder /></ProtectedRoute>
            }
            ]
          }]
      },
      {
        path: "/about-us",
        element: <About />,
      },
      {
        path: "/contact-us",
        element: <Contact />,
      },
      {
        path: "/track-applications",
        element: (
          <ProtectedRoute>
            <UserApplications />
          </ProtectedRoute>
        )
      },
      {
        path: '/track-applications/order/:orderId/details',
        element: (
          <ProtectedRoute>
            <AppliedApplicationDetails />
          </ProtectedRoute>
        )
      },
      {
        path: "/:user",
        element: (
          <ProtectedRoute>
            <UserDetails />
          </ProtectedRoute>
        ),
        children: [{
          path: "profile",
          element: (
            <ProtectedRoute>
              <UserBasicProfile />
            </ProtectedRoute>
          ),
        },
        {
          path: "documents",
          element: (
            <ProtectedRoute>
            <DocumentUploadAndVerification/>
            </ProtectedRoute>
          ),
        }
        ]
      },
    ],
  },
]);

const App = () => {
  // Dark mode is disabled for now — the app always uses the light theme.
  // (Dark mode will be implemented properly later; see darkTheme in createAppTheme.)
  return (
    <div className="App">
      <ErrorBoundary>
        <ThemeProvider theme={lightTheme}>
          {/* <Paper> */}
          <FirebaseAuth>
            <RouterProvider router={router} />
          </FirebaseAuth>
          {/* </Paper> */}
        </ThemeProvider>
      </ErrorBoundary>
    </div>
  );
};

export default App;
